import { getFormData } from '@avtkit/utils/functions';
import { AxiosRequestConfig } from 'axios';

export const loginByGoogle = (token: string): AxiosRequestConfig => ({
   url: `/mx/v1/auth/google`,
   method: 'POST',
   data: getFormData({ accessToken: token }),
});
